<template>
  <page>
    <span slot="page-title">Results</span>

    <h3 class="section-title mb-2">Wyoming - Polls Close 7pm mountain, 9pm eastern</h3>
    <v-layout row wrap>
      <v-flex class="iframe-flex-wrapper" xs12 sm6>
        <iframe src="https://prodapi.decisiondeskhq.com/ddhqembed.php?raceid= 2990&uid=9824a1de5c501d3d78ed63a93a6e50f891f199ef" width="450" height="235" frameborder="0" allowfullscreen=" allowfullscreen"></iframe>
      </v-flex>
      <v-flex class="iframe-flex-wrapper" xs12 sm6>
        <iframe src="https://prodapi.decisiondeskhq.com/ddhqembed.php?raceid= 2991&uid=9824a1de5c501d3d78ed63a93a6e50f891f199ef" width="450" height="200" frameborder="0" allowfullscreen=" allowfullscreen"></iframe>
      </v-flex>
      <v-flex class="iframe-flex-wrapper" xs12 sm6>
        <iframe src="https://prodapi.decisiondeskhq.com/ddhqembed.php?raceid= 2992&uid=9824a1de5c501d3d78ed63a93a6e50f891f199ef" width="450" height="175" frameborder="0" allowfullscreen=" allowfullscreen"></iframe>
      </v-flex>
      <v-flex class="iframe-flex-wrapper" xs12 sm6>
        <iframe src="https://prodapi.decisiondeskhq.com/ddhqembed.php?raceid= 2993&uid=9824a1de5c501d3d78ed63a93a6e50f891f199ef" width="450" height="150" frameborder="0" allowfullscreen=" allowfullscreen"></iframe>
      </v-flex>
      <v-flex class="iframe-flex-wrapper" xs12 sm6>
        <iframe src="https://prodapi.decisiondeskhq.com/ddhqembed.php?raceid= 2994&uid=9824a1de5c501d3d78ed63a93a6e50f891f199ef" width="450" height="255" frameborder="0" allowfullscreen=" allowfullscreen"></iframe>
      </v-flex>
    </v-layout>

    <h3 class="section-title mb-2">Alaska - Polls Close at 8pm Alaska/12am eastern</h3>
    <v-layout row wrap>
      <v-flex class="iframe-flex-wrapper" xs12 sm6>
        <iframe src="https://prodapi.decisiondeskhq.com/ddhqembed.php?raceid= 2995&uid=9824a1de5c501d3d78ed63a93a6e50f891f199ef" width="450" height="200" frameborder="0" allowfullscreen=" allowfullscreen"></iframe>
      </v-flex>
      <v-flex class="iframe-flex-wrapper" xs12 sm6>
        <iframe src="https://prodapi.decisiondeskhq.com/ddhqembed.php?raceid= 2996&uid=9824a1de5c501d3d78ed63a93a6e50f891f199ef" width="450" height="175" frameborder="0" allowfullscreen=" allowfullscreen"></iframe>
      </v-flex>
      <v-flex class="iframe-flex-wrapper" xs12 sm6>
        <iframe src="https://prodapi.decisiondeskhq.com/ddhqembed.php?raceid= 2997&uid=9824a1de5c501d3d78ed63a93a6e50f891f199ef" width="450" height="150" frameborder="0" allowfullscreen=" allowfullscreen"></iframe>
      </v-flex>
      <v-flex class="iframe-flex-wrapper" xs12 sm6>
        <iframe src="https://prodapi.decisiondeskhq.com/ddhqembed.php?raceid= 2998&uid=9824a1de5c501d3d78ed63a93a6e50f891f199ef" width="450" height="255" frameborder="0" allowfullscreen=" allowfullscreen"></iframe>
      </v-flex>
    </v-layout>
  </page>
</template>

<script>
import { Page } from '@/components'

const name = 'results'

const components = {
  Page
}

export default {
  name,
  components,
  metaInfo: {
    title: 'Results'
  }
}
</script>

<style>
.iframe-flex-wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
</style>
